module.exports = __webpack_public_path__ + "static/media/university.b916fbd6.png";